/*
 *  REST Service object: TrackerRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { doGetPromise, doDeletePromise } from '../../../core/config/core.httpclient-utils';
@Injectable()
export class TrackerRest {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    save(trackerId: number = 0, trackerData: any = {}) {
        return this.http.post(`/api/tracker/${trackerId}`, trackerData)
        .toPromise();
    }

    fetch(trackerId: number = 0, module: string = '', params: any = {}) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/${module}`, params);
    }

    assignees(trackerId: number = 0, filter: string) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/assignees`, { q: filter });
    }

    details(trackerId: number = 0, params: any = {}) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/details`, params);
    }
        
    members(trackerId: number = 0) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/members`);
    }

    projectQueries(trackerId: number = 0, queryStringData: any) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/queries`, queryStringData);
    }

    query(trackerId: number = 0, queryId: number = 0) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/query/${queryId}`);
    }
    
    postQuery(trackerId: number = 0, queryId: number, queryData: any = {}) {
        return this.http.post(`/api/tracker/${trackerId}/query/${queryId}`, queryData)
        .toPromise();
    }
        
    deleteQuery(trackerId: number = 0, queryId: number) {
        return this.http.delete(`api/tracker/${trackerId}/query/${queryId}`)
        .toPromise(); 
    }
        
    saveProjectQuery(queryData: any = {}) {
        return this.http.post(`/api/tracker/0/projectquery`, queryData)
        .toPromise();
    }

    delete(trackerId: number = 0) {
        return this.http.delete(`api/tracker/${trackerId}`)
        .toPromise();
    }
    
    deleteAssociation(trackerId: number = 0, relatedTrackerItemId: number = 0) {
        return this.http.delete(`/api/trackeritem/${trackerId}/association/${relatedTrackerItemId}`)
        .toPromise();
    }
        
    tefDelete(trackerId: number = 0, tefId: number = 0) {
        return this.http.delete(`api/tracker/${trackerId}/fields/${tefId}`)
        .toPromise();
    }

    tefPersist(trackerId: number = 0, tefData: any = {}) {
        return this.http.post(`/api/tracker/${trackerId}/fields`, tefData)
        .toPromise();
    }
        
    workflow(trackerId: number = 0) {
        return doGetPromise(this.http, `/api/tracker/${trackerId}/workflow`);
    }

}
